import { render, staticRenderFns } from "./ActivitySettingsCard.vue?vue&type=template&id=bb9d64d0"
import script from "./ActivitySettingsCard.vue?vue&type=script&lang=ts"
export * from "./ActivitySettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports